export default __webpack_public_path__ + "static/media/firebase.99786447.svg";